export default __webpack_public_path__ + "static/media/a6.32814568.png";